// bt-cluster-analytics.js
// Fires cluster-upsell events to GA4 (gtag) and PostHog (if present).
// Attaches after DOMContentLoaded to avoid blocking LCP.

(function () {
  'use strict';

  function fire(name, props) {
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', name, props || {});
      }
      if (window.posthog && typeof window.posthog.capture === 'function') {
        window.posthog.capture(name, props || {});
      }
      // Also dispatch a CustomEvent so other scripts / GTM can listen
      document.dispatchEvent(new CustomEvent('bt:' + name, { detail: props || {} }));
    } catch (e) {
      // Never let analytics break the page
    }
  }

  function init() {
    var cluster = document.querySelector('.bt-cluster');
    if (!cluster) return;

    var handle = cluster.getAttribute('data-product-handle') || '';
    var stage = cluster.getAttribute('data-cluster') || '';

    // View event — only once per session per product
    var viewKey = 'bt_cluster_view_' + handle;
    if (!sessionStorage.getItem(viewKey)) {
      fire('cluster_block_view', { product_handle: handle, stage: stage });
      try { sessionStorage.setItem(viewKey, '1'); } catch (e) {}
    }

    // Track individually-added variants to avoid double-add on bundle CTA
    var addedVariants = new Set();

    // Orb hover — engagement signal, debounced
    var hoverTimers = {};
    cluster.querySelectorAll('.bt-orb').forEach(function (orb) {
      orb.addEventListener('mouseenter', function () {
        var status = orb.className.match(/bt-orb--(built|partial|quiet)/);
        var key = (orb.querySelector('.bt-orb__label') || {}).textContent || '';
        clearTimeout(hoverTimers[key]);
        hoverTimers[key] = setTimeout(function () {
          fire('cluster_orb_hover', { product_handle: handle, stage: stage, domain: key, status: status ? status[1] : '' });
        }, 500);
      });
      orb.addEventListener('mouseleave', function () {
        var key = (orb.querySelector('.bt-orb__label') || {}).textContent || '';
        clearTimeout(hoverTimers[key]);
      });
    });

    // Companion add button
    cluster.querySelectorAll('[data-bt-cluster-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var variantId = btn.getAttribute('data-bt-cluster-add');
        var row = btn.closest('[data-handle]');
        var companionHandle = row ? row.getAttribute('data-handle') : '';
        fire('cluster_companion_add', { product_handle: handle, stage: stage, companion_handle: companionHandle, variant_id: variantId });
        addedVariants.add(variantId);
        addToCart(variantId);
      });
    });

    // Bundle CTA — adds all visible companions
    var ctaBtn = cluster.querySelector('[data-bt-cluster-add-all]');
    if (ctaBtn) {
      ctaBtn.addEventListener('click', function () {
        var variantIds = Array.from(cluster.querySelectorAll('[data-bt-cluster-add]'))
          .map(function (b) { return b.getAttribute('data-bt-cluster-add'); })
          .filter(function (id) { return !addedVariants.has(id); });
        fire('cluster_cta_click', { product_handle: handle, stage: stage, variant_ids: variantIds });
        Promise.all(variantIds.map(addToCart)).then(function () {
          if (window.PUB_SUB_EVENTS && typeof publish === 'function') {
            publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'bt-cluster-upsell' });
          } else {
            window.location.href = '/cart';
          }
        });
      });
    }
  }

  function addToCart(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    }).catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
